// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackToPreviews {
  margin: 1rem;
  /* padding: 1rem; */
  margin-top: 7rem;
  background-color: white;
  border-radius: 1rem;
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 3rem;
}
.BackToPreviews .list-wrapper {
  list-style: none;
  padding: 0;
  margin: 0;
  padding: 1rem;
  /* overflow: auto;
  scroll-behavior: smooth; */
}
.BackToPreviews .BackToProvide_container {
  /* width: 100%; */
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.BackToPreviews .list-wrapper .item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 0.5rem;
  min-width: 10rem;
  min-width: 5rem;
}
.BackToPreviews .list-wrapper .item .color-white {
  color: black !important;
  font-size: 0.9rem;
}
.whenActive .color-white,
.whenActive svg {
  color: white !important;
  font-size: 0.9rem;
}

.whenActive {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: var(--primary-color);
  border-radius: 1rem;
  padding: 0.5rem;
  min-width: 10rem;
}
.item .text-dark {
  color: black !important;
  font-size: 0.9rem;
}

.home-BackToPreviews-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.home-BackToPreviews-container .BackToPreviews {
  margin: 1rem 0;
  /* padding: 1rem; */
  margin-top: 7rem;
  background-color: white;
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 0%;
}

.home-BackToPreviews-container .BackToPreviews .BackToProvide_container {
  margin: 0;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.home-BackToPreviews-container .BackToPreviews .whenActive {
  border-radius: 0.5rem;
}

.br-1 {
  border-radius: 0.5rem;
}

.app-page {
  padding: 0 1.5rem;
  padding-top: 7rem;
}

.app-page .form-modal {
  background: #fff;
  padding: 1rem;
  display: flex;
  gap: 1rem;
}
.app-page .form-modal .form-section {
  width: 60%;
  padding: 1rem 2rem;
}
.app-page .form-modal .form-section .form-input {
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
}
.app-page .form-modal .form-section .f-label {
  font-size: 1.3rem;
  opacity: 0.7;
  padding-bottom: 5px;
}
.app-page .form-modal .list-section {
  padding: 1rem;
  width: 40%;
  max-height: 600px;
  overflow-y: auto;
}
.app-page .form-modal .list-section .avatar {
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 1s;
}
.app-page .form-modal .list-section .f-label {
  font-size: 1.3rem;
  opacity: 0.7;
  padding-bottom: 5px;
}
.app-page .form-modal .list-section .avatar .icon {
  font-size: 45px;
}
.app-page .form-modal .list-section .avatar-icon {
  height: 50px;
  width: 50px;
  border: 5px solid #a3a0a0;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/BackToPreviews.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb;4BAC0B;AAC5B;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;;EAEE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,SAAS;AACX;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".BackToPreviews {\r\n  margin: 1rem;\r\n  /* padding: 1rem; */\r\n  margin-top: 7rem;\r\n  background-color: white;\r\n  border-radius: 1rem;\r\n  width: 95%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  margin-left: 3rem;\r\n}\r\n.BackToPreviews .list-wrapper {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  padding: 1rem;\r\n  /* overflow: auto;\r\n  scroll-behavior: smooth; */\r\n}\r\n.BackToPreviews .BackToProvide_container {\r\n  /* width: 100%; */\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n  align-items: center;\r\n}\r\n.BackToPreviews .list-wrapper .item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 0.5rem;\r\n  min-width: 10rem;\r\n  min-width: 5rem;\r\n}\r\n.BackToPreviews .list-wrapper .item .color-white {\r\n  color: black !important;\r\n  font-size: 0.9rem;\r\n}\r\n.whenActive .color-white,\r\n.whenActive svg {\r\n  color: white !important;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.whenActive {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  background-color: var(--primary-color);\r\n  border-radius: 1rem;\r\n  padding: 0.5rem;\r\n  min-width: 10rem;\r\n}\r\n.item .text-dark {\r\n  color: black !important;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.home-BackToPreviews-container {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.home-BackToPreviews-container .BackToPreviews {\r\n  margin: 1rem 0;\r\n  /* padding: 1rem; */\r\n  margin-top: 7rem;\r\n  background-color: white;\r\n  width: 90%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  border-radius: 0%;\r\n}\r\n\r\n.home-BackToPreviews-container .BackToPreviews .BackToProvide_container {\r\n  margin: 0;\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n  align-items: center;\r\n}\r\n\r\n.home-BackToPreviews-container .BackToPreviews .whenActive {\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.br-1 {\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.app-page {\r\n  padding: 0 1.5rem;\r\n  padding-top: 7rem;\r\n}\r\n\r\n.app-page .form-modal {\r\n  background: #fff;\r\n  padding: 1rem;\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n.app-page .form-modal .form-section {\r\n  width: 60%;\r\n  padding: 1rem 2rem;\r\n}\r\n.app-page .form-modal .form-section .form-input {\r\n  padding: 0.5rem 1rem;\r\n  font-size: 1.2rem;\r\n}\r\n.app-page .form-modal .form-section .f-label {\r\n  font-size: 1.3rem;\r\n  opacity: 0.7;\r\n  padding-bottom: 5px;\r\n}\r\n.app-page .form-modal .list-section {\r\n  padding: 1rem;\r\n  width: 40%;\r\n  max-height: 600px;\r\n  overflow-y: auto;\r\n}\r\n.app-page .form-modal .list-section .avatar {\r\n  height: 50px;\r\n  width: 50px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  transition: 1s;\r\n}\r\n.app-page .form-modal .list-section .f-label {\r\n  font-size: 1.3rem;\r\n  opacity: 0.7;\r\n  padding-bottom: 5px;\r\n}\r\n.app-page .form-modal .list-section .avatar .icon {\r\n  font-size: 45px;\r\n}\r\n.app-page .form-modal .list-section .avatar-icon {\r\n  height: 50px;\r\n  width: 50px;\r\n  border: 5px solid #a3a0a0;\r\n  border-radius: 50%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
